// extracted by mini-css-extract-plugin
export default {"image":"BackgroundImage_image__lQ1rm"};